import React from 'react';
import './About.css';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const About = () => {
  const values = [
    {
      title: 'Technical Excellence',
      description: 'We maintain the highest standards in software engineering, architecture, and security practices.'
    },
    {
      title: 'Client Success',
      description: 'Your business outcomes drive our decisions. We measure success by the value we deliver.'
    },
    {
      title: 'Transparency',
      description: 'Clear communication, honest timelines, and straightforward pricing build lasting partnerships.'
    },
    {
      title: 'Continuous Innovation',
      description: 'We stay current with emerging technologies to provide forward-thinking solutions.'
    }
  ];

  const expertise = [
    'Cloud Architecture & Migration',
    'Enterprise Application Development',
    'AI & Machine Learning Integration'
  ];

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>Enterprise Technology Partner</h1>
          <p>
            Delivering mission-critical software solutions for organizations that demand 
            reliability, security, and scalability.
          </p>
        </div>
      </section>

      <section className="about-story">
        <div className="container">
          <div className="story-content">
            <h2>About SoftLaabs</h2>
            <p>
              SoftLaabs is a technology consulting firm specializing in enterprise software 
              development, cloud infrastructure, and digital transformation. We partner with 
              organizations across healthcare, financial services, retail, and manufacturing 
              to build secure, scalable systems that drive operational efficiency.
            </p>
            <p>
              Our team brings deep expertise in modern software architecture, cloud platforms, 
              and industry compliance requirements. We focus on delivering measurable business 
              value through technology solutions that are built to last.
            </p>
          </div>
        </div>
      </section>

      <section className="about-expertise">
        <div className="container">
          <div className="section-header">
            <h2>Core Expertise</h2>
            <p>Technical capabilities that power our solutions</p>
          </div>
          <div className="expertise-grid">
            {expertise.map((item, index) => (
              <div key={index} className="expertise-item">
                {item}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-values">
        <div className="container">
          <div className="section-header">
            <h2>Our Principles</h2>
            <p>How we work with clients and deliver projects</p>
          </div>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Discuss Your Project Requirements</h2>
            <p>Schedule a consultation to explore how we can support your technology initiatives.</p>
            <Link to="/contact">
              <Button 
                variant="contained"
                size="large"
                endIcon={<ArrowForwardIcon />}
                sx={{
                  backgroundColor: '#2271b1',
                  color: '#ffffff',
                  fontWeight: '600',
                  padding: '14px 32px',
                  fontSize: '15px',
                  textTransform: 'none',
                  borderRadius: '3px',
                  boxShadow: '0 1px 0 #135e96',
                  transition: 'all 0.2s',
                  '&:hover': {
                    backgroundColor: '#135e96',
                    transform: 'translateY(-1px)',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                  }
                }}
              >
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
